<template>
<div>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-card-title >
          3. Факторы, представляющие опасность для людей при пожаре
        </v-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" class="d-flex flex-column align-center justify-center">
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            v-model="tabs"
            @click="viewTab"

          >
            <v-img
              absolute
              lazy-src="img/material/explosion.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/explosion.svg"
            >
            </v-img>
          </v-card>
        </v-hover>
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            ref="flash"
            @click="viewTab2()"

          >
            <v-img
              lazy-src="img/material/flash.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/flash.svg"
            >
            </v-img>
          </v-card>
        </v-hover>
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            cursor:pointer
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            v-model="tabs"
            @click="viewTab3"
          >
            <v-img
              lazy-src="img/material/explosion-2.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/explosion-2.svg"
            >
            </v-img>
          </v-card>
        </v-hover>
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            cursor:pointer
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            v-model="tabs"
            @click="viewTab4"
          >
            <v-img
              lazy-src="img/material/fire-extinguisher.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/fire-extinguisher.svg"
            >
            </v-img>
          </v-card>
        </v-hover>

      </v-col>
      <v-col cols="8">
          <v-card
            flat
            class="d-flex align-center justify-center pa-2 white mb-10"
            height="200px"
          >
            <v-card-text v-model="message" class="title d-flex text-center justify-center font-weight-bold">
              {{ message }}
            </v-card-text>
          </v-card>
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white"
            cursor:pointer
            width="100%"
            style="cursor:pointer;"
            relative
          >
            <v-img
              lazy-src="img/material/fire-c.gif"
              max-height="100%"
              max-width="70%"
              contain
              absolute
              left
              src="img/material/man-burns.svg"
            >
            </v-img>
          </v-card>
      </v-col>
      <v-col  cols="2" class="d-flex flex-column align-center justify-center">
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            cursor:pointer
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            v-model="tabs"
            @click="viewTab5"
          >
            <v-img
              lazy-src="img/material/fire.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/fire.svg"
            >
            </v-img>
          </v-card>
        </v-hover>
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            cursor:pointer
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            v-model="tabs"
            @click="viewTab6"
          >
            <v-img
              lazy-src="img/material/thermometer.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/thermometer.svg"
            >
            </v-img>
          </v-card>
        </v-hover>
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            cursor:pointer
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            v-model="tabs"
            @click="viewTab7"
          >
            <v-img
              lazy-src="img/material/smoke.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/smoke.svg"
            >
            </v-img>
          </v-card>
        </v-hover>
        <v-hover
        v-slot="{ hover }"
        open-delay="200"
        >
          <v-card
            flat
            class="d-flex align-center justify-center pa-5 white mb-10"
            cursor:pointer
            width="250"
            :elevation="hover ? 4 : 2"
            style="cursor:pointer;"
            v-model="tabs"
            @click="viewTab8"
          >
            <v-img
              lazy-src="img/material/co2.svg"
              max-height="100%"
              max-width="50%"
              contain
              src="img/material/co2.svg"
            >
            </v-img>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex flex-column justify-center">
        <Hint></Hint>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>
<script>
import Hint from '@/components/Hint.vue'
export default {
  components: {
    Hint
  },
  data () {
    return {
      tabs: [
        { id: '1', text: 'Осколки, части разрушившихся аппаратов, агрегатов, установок, конструкций' },
        { id: '2', text: 'Электрическией ток, возникший в результате выноса высокого напржения на токопроводящие части конструкции, аппаратов, агрегатов' },
        { id: '3', text: 'Опасные факторы взрыва, происшедшего вследствии пожара' },
        { id: '4', text: 'Огнетушащие средства' },
        { id: '5', text: 'Открытый огонь и искры' },
        { id: '6', text: 'Повышенная температура окружающей среды и предметов' },
        { id: '7', text: 'Дым и токсичные продукты горения, термического разложения' },
        { id: '8', text: 'Пониженная концентрация кислорода' }
      ],
      message: '',
      text: 'Lorem '
    }
  },
  methods: {
    viewTab: function () {
      this.message = this.tabs[0].text
    },
    viewTab2: function () {
      this.message = this.tabs[1].text
    },
    viewTab3: function () {
      this.message = this.tabs[2].text
    },
    viewTab4: function () {
      this.message = this.tabs[3].text
    },
    viewTab5: function () {
      this.message = this.tabs[4].text
    },
    viewTab6: function () {
      this.message = this.tabs[5].text
    },
    viewTab7: function () {
      this.message = this.tabs[6].text
    },
    viewTab8: function () {
      this.message = this.tabs[7].text
    }
  }
}
</script>
